// extracted by mini-css-extract-plugin
module.exports = {"button":"CirlceButton_button__q5dmJ","small":"CirlceButton_small__YH5fz","large":"CirlceButton_large__Ap5JS"};